import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import PlaceholderWrapper from "../../Common/PlaceholderWrapper";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import SearchBar from "@mnjsplatform/components/lib/common/SearchBar";
import PopupWrapper from "../../Common/PopupWrapper";
import i18next from "i18next";
import PhotoGallery from "../../Common/fotorama/PhotoGallery";
import AuthProvider from "@mnjsplatform/data/lib/security/authProvider";
import pathJoin from "@mnjsplatform/data/lib/utils/pathJoin";
import $ from "jquery";
import {getWorkListPagesLinks} from "../../../actions/workDocumentsActions";
import {WorkplaceTypes} from "../../Common/constants";

class PersonalStage extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            selectedRowIndex: -1, updateGridFlag: null, showCopyBookViewer: false, images: null, selectedTabNum: null
        };
    }

    componentDidMount() {
        this.initialize();
    }

    async initialize() {
        try {
            await this.props.dispatch(this.props.dataItem_PersonList.execute({}, {
                withParams: true,
                withStyle: true
            }));
        } catch (e) {
            console.error(e);
        }
    }

    onPersonRowClick = async (row) => {
        const rowIndex = this.props.dataItem_PersonList.getRowIndex2(row);
        if (this.state.selectedRowIndex !== rowIndex) {
            let params = this.props.dataItem_PersonList.getRow(rowIndex);
            //await this.props.dispatch(this.props.dataItem_WorkList.reset());
            await this.props.dispatch(this.props.dataItem_WorkList.execute(params, {newItem: true}));
            this.setState({selectedRowIndex: rowIndex, updateGridFlag: Date.now()});
        }
    }

    onWorkStageCellClick = async (row, fieldInfo, e) => {
        if (fieldInfo.Name !== "IsCopyBookMsg" || row.IsCopyBook !== 1) {
            await this.onPersonRowClick(row);
        } else {
            await this.showWorkList(e, row);
        }
    }

    rowStyleProviderWorkStageSubForNewPO = (rowIndex, row) => {
        return (rowIndex === this.state.selectedRowIndex ? {backgroundColor: 'lightgrey', fontWeight: 'bold'} : {})
    };

    cellStyleProviderWorkStageSubForNewPO = (dataItem, rowIndex, fieldInfo) => {

        if (fieldInfo?.Name !== "IsCopyBookMsg") return null;

        if (dataItem?.getField(rowIndex, "IsCopyBook") !== 1) return null;

        return ({textDecoration: 'underline', fontWeight: 'bold', cursor: 'pointer'});
    };

    showWorkList = (e, row) => {
        e.preventDefault();
        return this.props.dispatch(getWorkListPagesLinks(row.TabNum))
            .then(() => {
                let urlList = [];
                if (this.props.image) {
                    urlList = this.props.image.map(image => {
                        return ({
                            img: window.config.apiRoot + image.img, thumb: window.config.apiRoot + image.thumb
                        })
                    });
                }
                this.setState({selectedTabNum: row.TabNum, showCopyBookViewer: urlList.length > 0, images: urlList});
            });
    };

    onCloseWorkListPopup = () => {
        this.setState({showCopyBookViewer: false, images: null/*, imagesLoaded: false*/});
    };

    downloadWorkList = () => {

        const tokenPromise = AuthProvider.getToken();

        tokenPromise.then(token => {

            const downloadPath = pathJoin(window.config.apiRoot, "WorkDocuments", "DownloadWorkList") + "?" + $.param({
                b_token: token,
                tabNum: this.state.selectedTabNum
            });

            window.open(downloadPath, '_blank');
        });
    };

    renderWorkListPopup = () => {
        if (!this.state.showCopyBookViewer) return null;

        let self = this;
        let imagesLoaded = this.state.images !== null;
        let imagesExists = imagesLoaded && this.state.images.length > 0;

        return (<PopupWrapper onClose={this.onCloseWorkListPopup}
                              popupVisible={this.state.showCopyBookViewer}
                              title={i18next.t("EmploymentHistoryCopy")}
                              renderButtons={() => {
                                  return <div className="modal-footer text-right">
                                      {imagesExists && <button type="button"
                                                               className="btn btn-regular -default"
                                                               data-dismiss="modal"
                                                               onClick={self.downloadWorkList}>
                                          {i18next.t('DownloadWorkList')}
                                      </button>}
                                      <button type="button"
                                              className="btn btn-regular -default"
                                              data-dismiss="modal"
                                              onClick={self.onCloseWorkListPopup}>
                                          {i18next.t('Close')}
                                      </button>
                                  </div>
                              }}>
            <div style={{minHeight: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                {imagesExists && <PhotoGallery imageList={this.state.images}/>}
                {imagesLoaded && !imagesExists && <span>{i18next.t("NoImages")}</span>}
                {!imagesLoaded && <span>{i18next.t("ImagesProcessing")}</span>}
            </div>
        </PopupWrapper>);
    };

    renderParams = (h) => {

        let fiNames = {};

        h.fs.forEach((item) => {
            fiNames[item.Name] = item.Name;
        });

        let searchBarFieldNames = {TFIO: 1};
        let searchBarFieldSet = this.props.dataItem_PersonList.rawData.ResultFieldInfo.filter(f => searchBarFieldNames[f.Name] != null)
            .map(f => f.Name);

        return (<React.Fragment>
            <div className="row">
                <div className="col-md-6">
                    <div className="field-title" style={{textAlign: 'left'}}>{h.lbl(fiNames.NumSub)}</div>
                    <div>{h.ed(fiNames.NumSub)}</div>
                </div>
                <div className="col-md-6">
                    <div className="field-title" style={{textAlign: 'left'}}>{h.lbl(fiNames.AdmStructName)}</div>
                    <div>{h.ed(fiNames.AdmStructName)}</div>
                </div>
            </div>
            <div className="row" style={{marginTop: '15px'}}>
                <div className="col-md-12">
                    <div className="field-title" style={{textAlign: 'left'}}>{i18next.t("SubordinateSearch")}</div>
                    <SearchBar dataItem={this.props.dataItem_PersonList} fieldSet={searchBarFieldSet}
                               autoFields={false}/>
                </div>
            </div>
        </React.Fragment>);
    };

    /*
        renderWorkStageCell = (row, fieldInfo, fieldIndex, renderCellDefault, rowIndex, dataItem, cellAttributes, customFieldExMap, readOnly) => {
            if(fieldInfo.Name !== "IsCopyBookMsg" || row.IsCopyBook !== 1)
                return renderCellDefault(row, fieldInfo, fieldIndex);

            return(
                <span style={{textDecoration: 'underline', fontWeight: 'bold', cursor: 'pointer'}} onClick={(e) => this.onCopyBookCellClick(row, e)}>{formatData(fieldInfo, row.IsCopyBookMsg)}</span>
            );
        };
    */

    renderData = () => {
        if (!this.props.dataItem_PersonList.isInitialized)
            return <span>{i18next.t("DataLoading")}</span>;

        return (<PlaceholderWrapper placeholderId="10"
                                    title={i18next.t("SubordinatesWorkExperience")}
                                    showSplitterLine={false} canCollapse={false}>

            <ComplexParam parentDataItem={this.props.dataItem_PersonList}
                          dataItem={this.props.dataItem_PersonList_Params}
                          renderParams={this.renderParams}
                          showApplyButton={false}
                          autoApplyParams={true}
                          readOnly={false}
                          showSearchBar={true}
                          rootPath="/"/>
            <div>&nbsp;</div>
            <GridView dataItem={this.props.dataItem_PersonList}
                      onCellClick={this.onWorkStageCellClick}
                      rowCursor={"pointer"}
                      rowStyleProvider={this.rowStyleProviderWorkStageSubForNewPO}
                      cellStyleProvider={this.cellStyleProviderWorkStageSubForNewPO}
                      allowPagination={true} pageSize={10} activePageSize={10}
                      updateStateFlag={{f: this.state.updateGridFlag}}/>
        </PlaceholderWrapper>);
    }

    renderPersonStageHistory = () => {

        if (this.state.selectedRowIndex < 0 || this.state.selectedRowIndex >= this.props.dataItem_PersonList.rowsCount())
            return null;
        let personName = this.props.dataItem_PersonList.getField(this.state.selectedRowIndex, "TFIO");
        let headerText = i18next.t("PersonalStage_WorkHistory", {person_name: personName});
        return (
            <PlaceholderWrapper placeholderId="30"
                                title={headerText}
                                staticTitle={i18next.t("PersonalStage_WorkHistory_Common")}
                                showSplitterLine={false} canCollapse={false}>
                <GridView dataItem={this.props.dataItem_WorkList}/>
            </PlaceholderWrapper>);
    }

    render() {
        return (<>
            {this.renderData()}
            {this.renderPersonStageHistory()}
            {this.renderWorkListPopup()}
        </>);
    }
}

PersonalStage.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataItem_PersonList: PropTypes.object,
    dataItem_PersonList_Params: PropTypes.object,
    dataItem_WorkList: PropTypes.object
};

PersonalStage.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        dataItem_PersonList: state.appState.appParams.workplaceType === WorkplaceTypes.Slavutich ?  state.personalStageState.PersonalStage_WorkStageSubForNewPO_Slav : state.personalStageState.PersonalStage_WorkStageSubForNewPO,
        dataItem_PersonList_Params: state.appState.appParams.workplaceType === WorkplaceTypes.Slavutich ?  state.personalStageState.PersonalStage_WorkStageSubForNewPO_SlavParams : state.personalStageState.PersonalStage_WorkStageSubForNewPOParams,
        dataItem_WorkList: state.personalStageState.PersonalStage_WorkListForPONew,
        image: state.workDocumentsState.image
    }
}

export default connect(mapStateToProps)(PersonalStage)